<template>
  <div @click="togglePlace" class="bg-white p-4">
    <div class="map-tip"></div>
    <a @click="closePlace" class="btn-close">
      <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><rect height="1" rx=".5" transform="matrix(.70710678 .70710678 -.70710678 .70710678 10.010408 -4.146447)" width="16" x="2.010408" y="9.510408"/><rect height="1" rx=".5" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -4.146447 10.010408)" width="16" x="2.010408" y="9.510408"/></g></svg>
    </a>
    <div class="mt-5">
      <div class="relative">
        <template v-if="!selectedPlace.isGooglePlace && token">
          <div class="float-right">
            <favorite :place="selectedPlace" />
          </div>
        </template>
        <template v-if="from.route">
          <div class="float-right plan-add">
            <a @click="addPlace">
              <div class="plan-add-icon">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 19 19"><path d="m370.514 224.9c.476 0 .882-.175 1.218-.525s.504-.763.504-1.239v-10.5c0-.476-.168-.882-.504-1.218s-.742-.504-1.218-.504h-10.5c-.476 0-.889.168-1.239.504s-.525.742-.525 1.218v10.5c0 .476.175.889.525 1.239s.763.525 1.239.525zm-4.389-2.625h-1.764v-3.486h-3.486v-1.764h3.486v-3.486h1.764v3.486h3.486v1.764h-3.486zm2.625 6.111v-1.722h-12.264v-12.264h-1.722v12.264c0 .476.168.882.504 1.218s.742.504 1.218.504z" transform="translate(-354 -210)" /></svg>
              </div>
            </a>
          </div>
        </template>
        <h2 class="pr-10 text-lg font-bold">
          {{ selectedPlace.name }}
        </h2>
      </div>
      <div class="mt-2 mb-1">
        <p v-for="benefit in selectedPlace.benefits" v-bind:key="benefit.id" class="inline-block py-1 px-2 mb-1 mr-2 border border-pass rounded text-pass text-sm text-center leading-none">
          {{ benefit.name }}
        </p>
      </div>
    </div>
    <div v-if="showPlaceFull" class="my-2">
      <place-full :place="selectedPlace">
        <progressive-img
          v-if="this.selectedPlace.image && selectedPlace.image.length > 0"
          :src="selectedPlace.image"
          class="w-full"
        />
      </place-full>
      <place-action :place="selectedPlace" />
    </div>
    <div v-else class="pt-2 text-sm text-center text-gray-600">
      詳細はこちらをタップ<br />
      ▼
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PlaceFull from './PlaceFull'
import Favorite from '../../molecules/Favorite'
import PlaceAction from './PlaceAction'

export default {
  components: {
    PlaceFull,
    Favorite,
    PlaceAction
  },
  computed: {
    ...mapGetters({
      selectedPlace: 'map/getSelectedPlace',
      showPlaceFull: 'map/getShowPlaceFull',
      from: 'map/getFrom',
      token: 'user/getToken'
    })
  },
  methods: {
    closePlace: function () {
      this.$store.dispatch('map/updateGooglePlaceMarker', {})
      this.$store.dispatch('map/updateSpalMarker', {})
      this.$store.dispatch('map/openPlace', { place: {}, full: false })
    },
    togglePlace: function () {
      this.$store.dispatch('map/openPlace', { place: this.selectedPlace, full: true })
    },
    addPlace: function () {
      if (this.selectedPlace.genreIds === undefined){
        this.selectedPlace.genreIds = ["other"]
      }
      const params = {
        route: this.from.route,
        place: this.selectedPlace
      }
      const fromParams = {
        ...this.from.params,
        fromMap: true
      }

      this.$store.dispatch('destinations/spliceDestination', params)
      this.$store.dispatch('routes/search')

      this.$router.push({ name: this.from.name, params: fromParams })
    }
  }
}
</script>
